module.exports = {
          srcSet: __webpack_public_path__ + "f2842f25.jpg"+" 700w"+","+__webpack_public_path__ + "8f9144db.jpg"+" 1400w"+","+__webpack_public_path__ + "02b12a15.jpg"+" 2100w"+","+__webpack_public_path__ + "dd743beb.jpg"+" 2622w",
          images:[ {path: __webpack_public_path__ + "f2842f25.jpg",width: 700,height: 410},{path: __webpack_public_path__ + "8f9144db.jpg",width: 1400,height: 820},{path: __webpack_public_path__ + "02b12a15.jpg",width: 2100,height: 1230},{path: __webpack_public_path__ + "dd743beb.jpg",width: 2622,height: 1536}],
          src: __webpack_public_path__ + "f2842f25.jpg",
          toString:function(){return __webpack_public_path__ + "f2842f25.jpg"},
          
          width: 700,
          height: 410
        }